import styled, { keyframes } from 'styled-components';

import { device } from '@/styles/helpers';

const scale = keyframes`
from {
  transform: scale(0.4);
}
to {
  transform: scale(1);
}
`;

export const ScTopSection = styled.div`
  position: relative;
  margin-top: -96px;
  padding: 104px 16px 0;
  overflow: hidden;
  min-height: 740px;

  @media (${device.mobile}) {
    padding: 84px 30px 0;
    min-height: 850px;
  }

  &::after {
    content: '';
    display: block;
    width: 100%;
    height: 200px;
    background: linear-gradient(0deg, #000 8.17%, rgba(0, 0, 0, 0) 100%);
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 1;

    @media (${device.mobile}) {
      height: 54px;
    }
  }

  & > .shine {
    position: absolute;
    border-radius: 590px;
    background: #f98921;
    opacity: 0.3;
    filter: blur(75px);
    animation: ${scale} 2s ease-out infinite alternate;
    width: 567px;
    aspect-ratio: 1;
    bottom: 0;

    @media (${device.mobile}) {
      width: 260px;
    }

    &.left {
      left: -210px;
      @media (${device.mobile}) {
        left: -48px;
      }
    }

    &.right {
      right: -296px;
      @media (${device.mobile}) {
        right: -48px;
      }
    }
  }

  & > .bg {
    object-fit: cover;
    object-position: top center;
  }

  .coins,
  .gift,
  .deskLeft,
  .deskRight {
    position: absolute;
  }

  .mob {
    display: none;
    position: absolute;

    @media (${device.mobile}) {
      display: block;
      position: relative;
      margin: 0 auto 24px;
      height: auto;
    }
  }

  .coins,
  .gift {
    top: 0;
    z-index: 2;
    @media (${device.mobile}) {
      width: 165px;
      height: 370px;
      top: -28px;
    }
  }

  .coins {
    left: -58px;
    @media (${device.mobile}) {
      left: -34px;
    }
  }

  .gift {
    right: -58px;
    @media (${device.mobile}) {
      right: -34px;
    }
  }

  .deskLeft {
    left: -105px;
    bottom: -11px;
    z-index: 1;

    @media (${device.mobile}) {
      width: 206px;
      height: 309px;
      left: -2px;
      bottom: -38px;
    }
  }

  .deskRight {
    right: -34px;
    bottom: -14px;
    z-index: 1;

    @media (${device.mobile}) {
      width: 195px;
      height: 243px;
      right: 6px;
      bottom: -31px;
    }
  }

  .mob {
    width: calc(100% - 32px);
  }

  & .bonuses-notice-box {
    margin-block: -16px 16px;
    width: min(480px, 100%);
    margin-inline: auto;
    position: relative;
    z-index: 5;

    &:empty {
      display: none;
      margin: 0;
    }
  }
`;
